import ajax from './ajax';

/* eslint-disable import/prefer-default-export */
export function requestCurrentUser() {
  return ajax('/resources/user/details/');
}

export function addUser(data) {
  return ajax('/users/add-user/', { method: 'POST', data });
}
